export function isMessage(value) {
    return /^(.|[\n\r\u2028\u2029]){0,1000}$/.test(value || '');
}
